import { render } from "./EditMarquee.vue?vue&type=template&id=1e0a033e"
import script from "./EditMarquee.vue?vue&type=script&lang=js"
export * from "./EditMarquee.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__